import type { UserGeo } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWRImmutable from "swr/immutable";

const useUserGeo = () => {
	const { userId } = useAuth();

	const {
		data: userGeo,
		isLoading,
		...rest
	} = useSWRImmutable<UserGeo>(userId && `/users/geo`);

	return { userGeo, isLoadingUserGeo: isLoading, ...rest };
};

export default useUserGeo;
